import axios from "@/plugins/axios";

export default {
    listParams(active = true, creditorId = null) {
        
        let params = {}

        params.active = active
        params.limit = 9999
        if (creditorId !== null) params.creditor_id = creditorId;

        return axios.httpApi.get("/creditor_consolidation_params", { params });
    }
};